import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import { useGlobalSearchUIStore } from '@flowwai-frontend/bps-officer-web/global-search'
import { useIsDashboardAdmin } from '@flowwai-frontend/bps-officer-web/iam'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import {
   NavFooter,
   NavHeader,
   useNavbarStore
} from '@flowwai-frontend/bps-officer-web/navbar-base'

import HomeNavbarBody from '../../components/HomeNavbarBody/HomeNavbarBody'

import { containerClassName } from './styles'

const HomeNavbarController = (): React.ReactElement => {
   const globalSearchUIStore = useGlobalSearchUIStore()
   const navbarStore = useNavbarStore()
   const isDashboardAdmin = useIsDashboardAdmin()

   const onClickSearch = () => {
      globalSearchUIStore.setGlobalSearchModalOpen()
   }

   // No-op function for dashboard admin users
   const noOpSearch = () => {
      // Intentionally empty - dashboard admin users should not have search functionality
   }

   const { theme } = useAppTheme()
   const { defaultNavItem: navItemTheme } = theme.navbar

   useEffect(() => () => navbarStore.clearStore(), [])

   return (
      <div
         className={cn(
            containerClassName,
            navItemTheme.bgColor,
            navItemTheme.borderColor
         )}
      >
         <NavHeader
            onClickSearch={isDashboardAdmin ? noOpSearch : onClickSearch}
            hideSearch={isDashboardAdmin}
         />
         <HomeNavbarBody />
         <NavFooter shouldShowAdminNavigationOption={false} />
      </div>
   )
}

export default observer(HomeNavbarController)
